import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';

const StyledSaveSearchDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(544)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(544)}, 86vw);
    height: clamp(0px, ${props => props.theme.layout(500)}, 86vh);
    max-height: clamp(0px, ${props => props.theme.layout(500)}, 86vh);
  }
  
  .SaveSearchDialog {
    &-content {
      height: 1px;
      padding: 0;
      overflow: visible;
      position: relative;
    }
  }
  
  ${ComponentStyles}
`;

StyledSaveSearchDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledSaveSearchDialog;
